interface QuestionMarkIconProps {
  size?: number;
}

const QuestionMarkIcon: React.FC<QuestionMarkIconProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path d="M9.2 9.2a2.9 2.9 0 0 1 5.63.97c0 1.93-2.9 2.9-2.9 2.9v.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 17.2v.01" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export default QuestionMarkIcon;
